<div class="name text-ellipsis">{{data.name}}</div>
<div class="full-width center-container">
  <app-login-input
    [maxLength]="phoneLength"
    [width]="260"
    [value]="phone()"
    (data)="phone.set($event)"/>
</div>
<div class="hint" i18n>
  我們將於商品開放訂購後，寄發簡訊通知您。
  <br/>
  因數量有限，此功能為貨到提醒，請恕無法保留商品。
</div>
<div class="submit-button-container">
  <button i18n appFocusRemove mat-dialog-close>取消</button>
  <button (click)="addRemind()" appFocusRemove i18n>送出</button>
</div>
